import Item from '../components/item/Item.vue';
import Form from '../components/form/Form.vue';

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.name;
    });
  },
  components: { Item, Form },
  data() {
    return {
      prevRoute: null,
      editItem: {},
      showDialogItem: false,
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        maxFiles: () => this.files.length < this.maxFilesLength
          || `Количество файлов не более ${this.maxFilesLength}`,
        minFiles: () => this.files.length >= this.minFilesLength
          || `Количество файлов не менее ${this.minFilesLength}`,
      },
    };
  },
  computed: {
    previousIsPortfolio() {
      return this.prevRoute === 'portfolio';
    },
    items() {
      return this.$store.state.jobs.items;
    },
    user() {
      return this.$store.state.user;
    },
  },
  mounted() {
    this.$store.dispatch('SetTitle', 'Мои работы');
    this.$store.dispatch('jobs/GetList');
  },
  methods: {
    EditItem(item) {
      this.editItem = item;
      this.showDialogItem = true;
    },
    Submit(item) {
      const url = item && item.id
        ? 'profiles/api/jobs/update'
        : 'profiles/api/jobs/create';
      this.$store.getters.axl
        .post(url, item)
        .then(() => {
          this.$store.dispatch('jobs/GetList');
          this.showDialogItem = false;
          this.editItem = {};
          this.$store.state.jobs.loading = false;
        })
        .catch((error) => {
          this.$store.state.jobs.loading = false;
          this.$store.dispatch('HandleError', error);
        });
    },
  },
};
